import {BaseModel} from "../../../infrastructure/models/base-model";

export class MetaTagModel extends BaseModel{
  name: String;
  content: String;

  constructor(name: String, content: String) {
    super();

    this.name = name;
    this.content = content;
  }
}